import React from 'react';
import { Grid, Typography } from '@mui/material';

const FinasterideMinoxidilInformation = () => (
  <Grid>
    <Typography variant="h6">About Finasteride</Typography>
    <br />
    <Typography variant="body1">
      Finasteride works by preventing the conversion of testosterone to dihydrotestosterone. Dihydrotestosterone is
      associated with a type of hair loss called androgenic alopecia. Androgenic alopecia is a form of hair loss that
      has a genetic component and results in different patterns of hair loss. Using Finasteride prevents hair loss and
      may help to regain previously lost hair.
    </Typography>
    <br />
    <br />
    <Typography variant="h6">How to use</Typography>
    <br />
    <Typography variant="body1">
      Finasteride is a once daily medication. Each dose is 1mg. Continuous use of Finasteride is required to maintain
      hair. A response is usually seen in 3-4 months and maximum response is seen by 1-2 years. Generally not all hair
      lost is recovered and Finasteride typically works better to prevent hair loss than to regrow it. If minimal
      response is seen by 12 months, talk to your Candor GP and reconsider use of Finasteride.
    </Typography>
    <br />
    <br />
    <Typography variant="h6">Side effects</Typography>
    <br />
    <Typography variant="body1">
      Finasteride is a commonly used medication and side effects are generally mild. However it is important to be aware
      of any potential adverse effects.
      <br />
      <br />
      Infrequent (0.1 - 1%)
      <br />
      - Impotence
      <br />
      - Decreased libido
      <br />
      - Decreased ejaculation volume
      <br />
      - Ejaculation disorders
      <br />
      <br />
      Rare (less than 0.1%)
      <br />
      - Breast tenderness/enlargement (gynaecomastia)
      <br />
      - Poor semen quality
      <br />
      - Infertility
      <br />
      - Depression
      <br />
      - Allergic reaction
      <br />
      <br />
      If you experience mild side effects please discuss these with your Candor GP. If you are concerned about them or
      experience any serious side effects please see your regular GP or present to the emergency department. Candor is
      unable to provide emergency medical advice. Please note further detailed information on Finasteride including
      usage and side effects will be provided in a medication safety information sheet with your prescription. It is
      important that you read this thoroughly before use.
    </Typography>
    <br />
    <br />
    <Typography variant="h6">Precautions - Prostate Cancer</Typography>
    <br />
    <Typography variant="body1">
      There is some concern that using Finasteride makes it more difficult to detect prostate cancer. Finasteride
      reduces PSA (prostate specific antigen) concentration by an average of 42% after 48 weeks. It is unclear how long
      after stopping finasteride PSA returns to normal, however this is likely to be within 6 months. PSA is used as a
      marker for prostate cancer, therefore it is important to let your regular GP know you are taking this medication
      as it can influence your results.
    </Typography>
    <br />
    <br />
    <Typography variant="h6">Can I use Finasteride when pregnant?</Typography>
    <br />
    <Typography variant="body1">
      No. Finasteride should not be taken by pregnant women as it may cause fetal harm. Finasteride is not used for hair
      loss in women and Candor does not prescribe Finasteride to women. As a precaution it is recommended that pregnant
      women do not handle crushed or broken tablets although this is unlikely to result in enough absorption to cause
      harm.
    </Typography>
    <br />
    <br />
    <Typography variant="h6">Can I use Finasteride when breastfeeding?</Typography>
    <br />
    <Typography variant="body1">
      Finasteride is not used for hair loss in women and Candor does not prescribe Finasteride to women. It is not known
      if Finasteride is excreted in breastmilk and is not recommended to be used.
    </Typography>
    <br />
    <br />
    <Typography variant="h6">About Minoxidil</Typography>
    <br />
    <Typography variant="body1">
      Minoxidil promotes hair growth by increasing the length of the growth cycle of hair and enlarging hair follicles.
      More information on how hair grows and why you may be experiencing hair loss can be found on our website under
      hair treatments.
    </Typography>
    <br />
    <Typography variant="h6">How to use</Typography>
    <br />
    <Typography variant="body1">
      Minoxidil is a topical treatment in the form of a liquid or foam. It is applied to areas when hair growth is
      required.
      <br />
      <br />
      If using the liquid, apply 1ml twice a day.
      <br />
      <br />
      If using the foam apply approximately half a capful twice a day (for men) or once a day (for women).
      <br />
      <br />
      There are several important considerations when using minoxidil:
      <br />
      <br />
      - Avoid contact with eyes
      <br />
      - Apply to dry skin and hair. Make sure to wash hands thoroughly after application to avoid transfer to other
      areas
      <br />
      - Allow hair to dry completely before going to bed
      <br />
      - Do not wear a wig, scarf or hat for at least 1 hour after use to avoid excess absorption
      <br />- Wait at least 4 hours after use before washing hair
    </Typography>
    <br />
    <Typography variant="h6">Side effects</Typography>
    <br />
    <Typography variant="body1">
      Minoxidil is a commonly used medication and side effects are generally mild. However it is important to be aware
      of any potential adverse effects.
      <br />
      <br />
      Common (More than 1%):
      <br />
      - Itch
      <br />
      - Erythema
      <br />
      - Dry skin
      <br />
      - Dermatitis
      <br />
      - Hypertrichosis (excess hair growth)
      <br />
      <br />
      Hypertrichosis is more common in women, particularly if high strengths are used. This commonly occurs on the face
      but may occur in other areas. It is important to read the instructions on how to use carefully.
      <br />
      <br />
      When first using minoxidil a temporary increase in hair loss may occur. Increase in hair growth generally occurs
      after 3-4 months of treatment and minoxidil use needs to be continued to keep seeing a benefit. On stopping
      minoxidil use, hair that is grown may be lost again. If no benefit is seen after 6 months, discuss with your
      Candor GP.
      <br />
      <br />
      Please note further detailed information on Minoxidil including usage and side effects will be provided in a
      medication safety information sheet with your prescription. It is important that you read this thoroughly before
      use.
    </Typography>
    <br />
    <Typography variant="h6">Can I use Minoxidil when pregnant?</Typography>
    <br />
    <Typography variant="body1">
      No. There is limited data on Minoxidil use in pregnancy and it is therefore not recommended.
    </Typography>
    <br />
    <Typography variant="h6">Can I use Minoxidil when breastfeeding?</Typography>
    <br />
    <Typography variant="body1">
      While Minoxidil appears to be safe when breastfeeding, it does appear to be transmitted to breastmilk and may have
      effects on infants. Therefore we do not recommend use.
    </Typography>
  </Grid>
);

export default FinasterideMinoxidilInformation;
